module.exports = __webpack_public_path__ + "img/zgsy.2525b0aa.svg";